import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import axios from "axios";

import { DashboardLayout } from "../../../Layout/DashboardLayout";
import BackButton from "../../../Components/BackButton";
import CustomInput from "../../../Components/CustomInput";
import CustomButton from "../../../Components/CustomButton";
import { questionModal, successModal } from "../../../Components/CustomModal";
import CustomLoader from "../../../Components/CustomLoader";
import BASEURL from "../../../Config/global";
import { getRequest, patchRequest } from "../../../Util/requests";
import { placeholderImage } from "../../../Assets/images";

const EditDashboardLink = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const [formData, setFormData] = useState({
        name: "",
        description: "",
        website_link: "",
        play_link: "",
        read_link: "",
        type_id: "",
    });
    const [typeOptions, setTypeOptions] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState({ error: false, text: "" });

    useEffect(() => {
        fetchTypes();
        fetchData();
    }, [id]);

    const GET_DASHBOARD_LINK_TYPES = "/api/user/dashboard-link-types/";
    const fetchTypes = async () => {
        try {
            const response = await getRequest(GET_DASHBOARD_LINK_TYPES);
            if (response.data.data) {
                setTypeOptions(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching types:", error);
        }
    };

    const fetchData = async () => {
        setLoader(true);
        try {
            const response = await axios.get(`${BASEURL}/api/user/dashboard-links/${id}/`);
            if (response.data.data && response.data.data[0]) {
                const item = response.data.data[0];
                setFormData({
                    name: item.name || "",
                    description: item.description || "",
                    website_link: item.website_link || "",
                    play_link: item.play_link || "",
                    read_link: item.read_link || "",
                    type: item.type || "",
                    type_id: item.type_id || "",
                });
                setImagePreview(item.image_link);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoader(false);
        }
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedImage(file);
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                setImagePreview(reader.result);
            };
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!formData.name || !formData.type_id) {
            setError({ error: true, text: "Please fill all required fields." });
            return;
        }

        questionModal.fire({
            title: "Do you want to update this Product  Link?",
            confirmButtonText: "Update",
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoader(true);
                const formDataToSend = new FormData();
                formDataToSend.append("name", formData.name);
                formDataToSend.append("description", formData.description);
                formDataToSend.append("website_link", formData.website_link);
                formDataToSend.append("play_link", formData.play_link);
                formDataToSend.append("read_link", formData.read_link);
                formDataToSend.append("type", formData.type);
                formDataToSend.append("type_id", formData.type_id);

                if (selectedImage) {
                    formDataToSend.append("image_link", selectedImage);
                }

                try {
                    const response = await patchRequest(`/api/user/dashboard-links/${id}/`, formDataToSend, null);
                    if (response.data.error === false) {
                        successModal.fire({
                            text: "Product  Link Updated Successfully",
                            confirmButtonText: "Continue",
                        });
                        navigate("/scofa-dashboard");
                    } else {
                        setError({ error: true, text: response.data.message });
                    }
                } catch (error) {
                    setError({ error: true, text: "An error occurred. Please try again later." });
                } finally {
                    setLoader(false);
                }
            }
        });
    };

    return (
        <>
            <DashboardLayout>
                <div className="container-fluid">
                    <div className="row mb-3">
                        <div className="col-12">
                            <h2 className="mainTitle">
                                <BackButton />
                                Edit Product Link
                            </h2>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-10">
                            <form onSubmit={handleSubmit}>
                                <div className="row mb-3">
                                    <div className="col-lg-4 mb-2">
                                        <CustomInput
                                            label="Name"
                                            labelClass="mainLabel"
                                            required
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            placeholder="Enter Name"
                                            inputClass="mainInput"
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-lg-4 mb-2">
                                        <p className="mainLabel">Category*</p>
                                        <select
                                            name="type_id"
                                            className="mainInput mt-1"
                                            required
                                            value={formData.type_id}
                                            onChange={handleChange}
                                        >
                                            <option value="">SELECT TYPE</option>
                                            {typeOptions.map((type) => (
                                                <option key={type.id} value={type.id}>
                                                    {type?.name?.toUpperCase()}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <CustomInput
                                            label="Subtitle"
                                            labelClass="mainLabel"
                                            type="text"
                                            name="description"
                                            value={formData.description}
                                            placeholder="Enter Subtitle"
                                            inputClass="mainInput"
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-4 mb-2">
                                        <CustomInput
                                            label="Read Link"
                                            labelClass="mainLabel"
                                            type="url"
                                            name="read_link"
                                            value={formData.read_link}
                                            placeholder="https://..."
                                            inputClass="mainInput"
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-lg-4 mb-2">
                                        <CustomInput
                                            label="Website Link"
                                            labelClass="mainLabel"
                                            type="url"
                                            name="website_link"
                                            value={formData.website_link}
                                            placeholder="https://..."
                                            inputClass="mainInput"
                                            onChange={handleChange}
                                        />
                                    </div>
                                    {
                                        Number(formData.type_id) === 2 || Number(formData.type_id) === 6 ? (
                                            <div className="col-lg-4 mb-2">
                                                <CustomInput
                                                    label="Play Link"
                                                    labelClass="mainLabel"
                                                    type="url"
                                                    name="play_link"
                                                    value={formData.play_link}
                                                    placeholder="https://..."
                                                    inputClass="mainInput"
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        ) : <div className="col-lg-4 mb-2"></div>
                                    }
                                    <div className="col-lg-4 mb-2">
                                        <p className="mainLabel">Image</p>
                                        <label className="d-block">
                                            <div className="imageInput" style={{ height: '300px', cursor: 'pointer' }}>
                                                <img src={imagePreview || placeholderImage} alt="Preview" className="w-100 h-100" style={{ objectFit: 'cover', borderRadius: '8px' }} />
                                            </div>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                className="d-none"
                                                onChange={handleImageChange}
                                            />
                                        </label>
                                    </div>
                                </div>


                                {error.error && (
                                    <p className="secondaryText text-danger">{error.text}</p>
                                )}
                                <div className="row mt-4">
                                    <div className="col-12 text-start">
                                        <CustomButton type="submit" variant="primaryButton" text="UPDATE" className="btn-lg px-5" />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </DashboardLayout>
            {loader && <CustomLoader />}
        </>
    );
};

export default EditDashboardLink;
